"use client"

import DashboardContentWrapper from '@/shared/components/dashboard-content-wrapper'
import Heading from '@/shared/components/ui/typography/heading'
import { Alert, AlertDescription } from '@/shared/components/ui/alert'
import { Construction } from 'lucide-react'

interface MigrationPlaceholderProps {
  regionName?: string
}

export default function MigrationPlaceholder({ regionName }: MigrationPlaceholderProps) {
  return (
    <DashboardContentWrapper className="flex flex-col items-center justify-center gap-6 py-24">
      <Construction className="h-12 w-12 text-muted-foreground" />
      <div className="space-y-4 text-center">
        <h1 className="text-3xl font-semibold tracking-tight">
          {regionName ? `${regionName} Migration Tool` : 'Migration Tool'}
        </h1>
        <Alert>
          <AlertDescription>
            This migration tooling is under construction. A region-specific solution will be available soon.
          </AlertDescription>
        </Alert>
      </div>
    </DashboardContentWrapper>
  )
}
